import type { WithActiveBranchId } from '@app/api/shared';

export enum LoggerEndpoints {
  GetSystemLogsByPeriod = 'GetSystemLogsByPeriod',
  ExportSystemLogsByPeriodToExcel = 'ExportSystemLogsByPeriodToExcel',
  ClearSystemLogs = 'ClearSystemLogs',
  GetLogs = 'GetLogs',
  GetLogById = 'GetLogById',
}

export interface LoggerModelSystemLogLite {
  Id: number;
  Timestamp: string;
  Module: string | null;
  Error: string | null;
}

export interface LoggerLogFilters {
  Module: string | null;
  Level: string | null;
  DateFrom: string | null;
  DateTo: string | null;
}

export interface LoggerLogDto {
  Id: number;
  Message: string | null;
  Level: string | null;
  Timestamp: string;
  Exception: string | null;
  Module: string | null;
  Properties: Record<string, unknown> | null;
  FormattedTimestamp: string | null;
}

export interface LoggerLogsResponse {
  Logs: LoggerLogDto[] | null;
  PageN: number;
  PageSize: number;
  CountPages: number;
  CountItems: number;
  Filters: LoggerLogFilters;
}

export interface LoggerModelFile {
  Id: number;
  Name: string | null;
  Data: string | null;
  Lifetime: string | null;
  Description: string | null;
}

export type GetSystemLogsByPeriodRequest = WithActiveBranchId<{
  dateS?: string;
  dateE?: string;
}>;

export type ExportSystemLogsByPeriodToExcelRequest = WithActiveBranchId<{
  dateS?: string;
  dateE?: string;
}>;

export type ClearSystemLogsRequest = WithActiveBranchId;

export type GetLogsRequest = WithActiveBranchId<{
  module?: string;
  level?: string;
  dateS?: string;
  dateE?: string;
  page?: number;
  pageSize?: number;
  searchText?: string;
}>;

export type GetLogByIdRequest = WithActiveBranchId<{
  id: number;
}>;

export type GetSystemLogsByPeriodResponse = LoggerModelSystemLogLite[];
export type ExportSystemLogsByPeriodToExcelResponse = LoggerModelFile;
export type ClearSystemLogsResponse = void;
export type GetLogsResponse = LoggerLogsResponse;
export type GetLogByIdResponse = LoggerLogDto;
